import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useLazyGetDestinationAnalyticsQuery } from "../../../../services/Api";
import LoaderSpiner from "../../../../components/loaderSpiner";

const COLORS = ["#4B5563", "#10B981", "#F97316", "#FFD700", "#3B82F6"];

function DestinationChart() {
  const [chartData, setChartData] = useState([]);
  const [total, setTotal] = useState(0);
  const [trigger, { data: Data, isLoading, error }] =
    useLazyGetDestinationAnalyticsQuery();

  useEffect(() => {
    trigger();
  }, [trigger]);

  useEffect(() => {
    if (Data?.data?.countriesWithPackingLists) {
      const transformedData = Data?.data?.countriesWithPackingLists.map(
        (item) => ({
          name: item.country,
          value: item.value,
        })
      );
      setChartData(transformedData);
      const totalValue = transformedData.reduce(
        (sum, item) => sum + item.value,
        0
      );
      setTotal(totalValue);
    }
  }, [Data]);

  if (isLoading) return <LoaderSpiner />;
  if (error) return <div>Error loading data</div>;

  return (
    <div className="w-full h-full min-h-[300px] flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4 w-full">
        <div className="w-[200px] h-[200px] sm:w-[220px] sm:h-[220px] relative">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius="60%"
                outerRadius="85%"
                startAngle={90}
                endAngle={450}
                dataKey="value"
                strokeWidth={0}
              >
                {chartData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: "#F9FAFB",
                  color: "#333",
                  borderRadius: "8px",
                  padding: "8px",
                  fontSize: "14px",
                }}
                labelStyle={{
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
                formatter={(value, name) => [`${value}`, `${name}`]}
              />
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <span className="text-xl sm:text-2xl font-bold">{total}</span>
          </div>
        </div>

        {/* Legend */}
        <div className="flex justify-center items-center flex-wrap gap-4 mb-4">
          {chartData.map((entry, index) => (
            <div key={entry?.name} className="flex items-center gap-2">
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              ></div>
              <span className="text-sm">{entry?.name}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default DestinationChart;
